import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {Insurer} from './Insurer';
import {TokenAssure} from './token-assure';
import {DataPosition} from './data-position';
import {environment} from '../../environments/environment';
import {UserInformation} from './user-information';

@Injectable()
export class DossierService {

  private VISIOTEX_BASE_URL = environment.visiotexBaseURL;

  constructor(private httpClient: HttpClient) {
  }

  getInsurer(hash: string): Observable<Insurer> {
    return this.httpClient.post<any>(this.VISIOTEX_BASE_URL + '/info/DossierService.svc/Insurer', {hash: hash})
      .map(response => response.Response);
  }

  getTokenAssure(refSinistre: string): Observable<TokenAssure> {
    return this.httpClient.get<any>(this.VISIOTEX_BASE_URL + '/host/VisioService.svc/GetTokenAssure?num=' + refSinistre)
      .map(response => response.Response);
  }

  updatePositionVisio(dataPosition: DataPosition): Observable<any> {
    return this.httpClient.post<any>(this.VISIOTEX_BASE_URL + '/host/VisioService.svc/UpdatePositionVisio', dataPosition);
  }

  sendUserInformation(information: UserInformation): Observable<any> {
    return this.httpClient.post<any>(this.VISIOTEX_BASE_URL + '/host/VisioService.svc/LogDeviceInformation', information);
  }
}



// WEBPACK FOOTER //
// ./src/app/dossier/dossier.service.ts